import type { MODULATOR_APPLIANCES_TABLE_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/modulator-appliances-table-card/modulator-appliances-table-card.fr.ts";

export const MODULATOR_APPLIANCES_TABLE_CARD_ENGLISH_LOCALE = {
  title: "Appliances",
  searchPlaceholder: "Search a value...",
  table: {
    headers: {
      way: "Way",
      csId: "Id CS",
      hwId: "Id Hardware",
      applianceType: "Appliance type",
      location: "Location",
    },
    empty: "No appliance have been found",
  },
} satisfies typeof MODULATOR_APPLIANCES_TABLE_CARD_FRENCH_LOCALE;
